import React from 'react';
import './Toast.css';
import {ToastsContainer, ToastsStore,ToastsContainerPosition} from 'react-toasts';
const Toast=()=>{
  return <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground/>
}
export default Toast
